import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function DifferentiationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-8 md:py-16 px-4" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6 md:mb-8" data-id="element-53">
            WHAT MAKES THIS DIFFERENT
          </h2>

          <p className="text-lg md:text-xl font-semibold text-navy mb-6 md:mb-8" data-id="element-54">
            Most resources are built for browsing. This one is built for use.
          </p>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" data-id="element-55">
            <p data-id="element-56">
              Everything is organized by grade level and week. Everything is
              editable. Everything is connected. There is a coherent
              through-line from the first lesson of the year to the last
              performance.
            </p>

            <p className="text-lg md:text-xl font-bold text-navy pt-4" data-id="element-57">
              You are not buying a product. You are buying a system.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-8 md:mt-12 pt-8 md:pt-12 border-t-2 border-gold" data-id="element-58">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6 md:mb-8" data-id="element-59">
            THIS IS NOT FOR EVERYONE
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" data-id="element-60">
            <p data-id="element-61">
              If you are looking for a rigid script, this is not it. Every
              lesson plan is a starting point.
            </p>

            <p data-id="element-62">
              If you want something that saves you time this week but not next
              week, this is not it. The Mega Music Pack is a full-year system.
            </p>

            <p className="text-lg md:text-xl font-bold text-navy pt-4" data-id="element-63">
              But if you are a music teacher who loves teaching and is done
              planning from scratch every single week — this was built for you.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}